import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Container,
} from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import DescriptionIcon from "@mui/icons-material/Description";
import RouteIcon from "@mui/icons-material/AltRoute";
import HistoryIcon from "@mui/icons-material/History";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SendIcon from "@mui/icons-material/Send";

const NAV = [
  { to: "/send", label: "Send", icon: <SendIcon /> },
  { to: "/apps", label: "Apps", icon: <AppsIcon /> },
  { to: "/templates", label: "Templates", icon: <DescriptionIcon /> },
  { to: "/providers", label: "Providers", icon: <RouteIcon /> },
  { to: "/audit", label: "Audit", icon: <HistoryIcon /> },
];

const DRAWER_WIDTH = 220;

export function DashboardLayout() {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (t) => t.zIndex.drawer + 1,
          bgcolor: "background.paper",
          color: "text.primary",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Toolbar>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: 1,
              mr: 1.25,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #0E7C7B 0%, #3FA2A1 100%)",
              color: "#FFFFFF",
            }}
          >
            <MailOutlineIcon sx={{ fontSize: 20 }} />
          </Box>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
            īmēra
          </Typography>
          <Button
            color="inherit"
            onClick={async () => {
              await signOut();
              navigate("/auth", { replace: true });
            }}
          >
            Sign out
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: DRAWER_WIDTH,
            boxSizing: "border-box",
            borderRight: "1px solid",
            borderColor: "divider",
          },
        }}
      >
        <Toolbar />
        <List>
          {NAV.map((item) => (
            <ListItemButton
              key={item.to}
              component={NavLink}
              to={item.to}
              sx={{
                "&.active": {
                  bgcolor: "action.selected",
                  color: "primary.main",
                  "& .MuiListItemIcon-root": { color: "primary.main" },
                },
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: "background.default" }}>
        <Toolbar />
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}
